declare namespace $ {

	type $shm_hitalama_map_widget_float_table_select__Filter_shm_hitalama_map_widget_float_table_filter_1 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['Filter'] >
	>
	type $shm_hitalama_map_widget_float_table_select__value_shm_hitalama_map_widget_float_table_filter_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_filter['mode'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['value'] >
	>
	type $shm_hitalama_map_widget_float_table_select__dictionary_shm_hitalama_map_widget_float_table_filter_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_filter['modes'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_select['dictionary'] >
	>
	type $mol_string__hint_shm_hitalama_map_widget_float_table_filter_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_filter['value_hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_table_filter_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_filter['value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_map_widget_float_table_filter_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_filter['until_hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_table_filter_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_filter['until'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_status__message_shm_hitalama_map_widget_float_table_filter_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_filter['error'] >
		,
		ReturnType< $mol_status['message'] >
	>
	export class $shm_hitalama_map_widget_float_table_filter extends $mol_view {
		mode( next?: string ): string
		modes( ): Record<string, any>
		Mode( ): $shm_hitalama_map_widget_float_table_select
		value_hint( ): string
		value( next?: string ): string
		Value( ): $mol_string
		until_hint( ): string
		until( next?: string ): string
		Until( ): $mol_string
		inputs( ): readonly(any)[]
		error( ): string
		Error( ): $mol_status
		kind( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=filter.view.tree.d.ts.map